export default __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLGT9Z11lFc-K.5bd4e0d6.woff2";